import React from 'react';

import { Link, Message } from './styled';

interface IRenderMessageProps {
    isError: boolean,
    message: string | null | undefined,
    openChatHandler: () => void,
}

export const RenderMessage = ({ isError, message, openChatHandler }: IRenderMessageProps) => {
    if (isError && message === undefined) {
        return <Message isError={isError}>
            Неизвестная ошибка, попробуйте оставить заявку позднее или напишите нам в&nbsp;
            <Link onClick={openChatHandler}>чат</Link>.
        </Message>;
    }
    if (message === null) {
        return null;
    }
    return <Message isError={isError}>{message}</Message>;
};
